import { css } from 'styled-components';
import {
  getSpacing, getTypography, TypographyName, SpacingName, BreakpointQueryName, ThemedFunctor, rgba,
} from '@doveit/bricks';

export const basic: ThemedFunctor = ({
  theme,
  $interactive,
}) => css`
  position: relative;
  overflow: hidden;
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.ZERO])}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    ${$interactive && `
      &:hover {
        box-shadow: 0 0 10px rgba(0,0,0,0.3);

        h4 {
          text-decoration: underline;
        }
      }`}
  }
`;

export const overlayLink = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: block;
  cursor: pointer;
`;

export const placeholder: ThemedFunctor = ({
  theme,
}) => css`
  background-color: ${theme.palettes.neutrals.light};
  position: relative;
  padding-top: 66.6%;

  svg {
    width: 7rem;
    fill: ${theme.palettes.neutrals.lightest};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  max-width: 32rem;
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: flex;
  }
`;

export const preview: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.mobile.SMALLER};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 21.5rem;
    flex-shrink: 0;
    margin-top: 0;
  };
`;

export const previewWrapper = css`
  position: relative;
`;

export const badges = css`
  position: absolute;
  top: .5rem;
  left: .5rem;
  right: 0;
  z-index: 2;
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
`;

export const banner: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  text-align: center;
  background-color: ${rgba(theme.palettes.brand.primary, 0.8)};
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  padding: 1rem;
  transform: translateY(-50%);
  color: ${theme.palettes.neutrals.lightest};
  text-transform: uppercase;
  z-index: 2;
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    order: 2;
    flex-grow: 1;
    padding-left: ${theme.spaceUnits.desktop.MEDIUM};
    padding-bottom: 3.5rem;
    position: relative;
  }
`;

export const suburb: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  margin-top: ${theme.spaceUnits.mobile.SMALLEST};
  max-width: 32rem;
`;

export const image = css`
  position: relative;
  z-index: 1;
`;

export const price: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  margin-top: ${theme.spaceUnits.mobile.SMALLER};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    position: absolute;
    top: 0;
    right: 2rem;
    margin-top: 0;
  }
`;

export const buildingSiteLogo: ThemedFunctor = ({
  theme,
}) => css`
  display: none;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
    margin-top: ${theme.spaceUnits.desktop.SMALLER};
    img {
      max-width: 7.5rem !important;
      max-height: 3.75rem !important;
      line-height: 0;
    }
  }
`;

export const description: ThemedFunctor = ({ theme }) => css`
  margin-top: ${theme.spaceUnits.desktop.SMALLER};
  ${getTypography(theme, TypographyName.BODY)}
  display: none;
  max-width: 32rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const actions: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.desktop.SMALLER};
  position: absolute;
  bottom: 0;
  left: auto;
  z-index: 3;
  display: none;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const mobileActions: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.mobile.SMALLER};
  position: relative;
  z-index: 3;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: none;
  }
`;

export const highlights: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)};
`;
